import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const bookmarkObject = async (id: string) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.contentObjects.bookmark.create(id));
